export default {
  bold: 'Avenir-Bold',
  regular: 'Avenir-Regular',
}
